import BookForm from "./BookForm";
import { Grid } from "@mui/material";
import Header from "../../components/custom/Header";

import { styled } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getBook, singleBookUpload } from "../../services/booksServices";
import { useRef, useState } from "react";
import Dialog from "../../components/custom/Dialog";
import { UNAUTHORIZEDREQUEST } from "../../constants";
import {
  BOOK_STATUS_STARTED,
  BOOK_STATUS_UPLOADED,
  BOOK_STATUS_PUBLISHED,
  BOOK_STATUS_INVALID,
  BOOK_STATUS_CANCELLED,
} from "../../constants/generalConstants";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const EditBook = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useQuery(["book", id], () => getBook(id), {
    enabled: !!id,
    retry: (failureCount, error) => {
      if (error.response.status === UNAUTHORIZEDREQUEST) {
        navigate("/");
      }
    },
  });
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  const formikRef = useRef();

  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Header name="Edit Book" />

        <BookForm
          formikRef={formikRef}
          edit={
            data?.data?.status === BOOK_STATUS_UPLOADED ||
            data?.data?.status === BOOK_STATUS_STARTED
          }
          disabledDistributors={
            data?.data?.status === BOOK_STATUS_PUBLISHED ||
            data?.data?.status === BOOK_STATUS_CANCELLED ||
            data?.data?.status === BOOK_STATUS_INVALID
          }
          initialValues={data?.data}
          onSubmit={async () => {
            setMessage("Editing...");
            setUploading(true);
            let book = {
              id: formikRef?.current?.values?.id,
              status: formikRef?.current?.values?.status,
              title: formikRef?.current?.values?.title,
              author: formikRef?.current?.values?.author,
              bookCategory: formikRef?.current?.values?.bookCategory,
              description: formikRef?.current?.values?.description,
              year: formikRef?.current?.values?.year,
              isbn: formikRef?.current?.values?.isbn,
              origin: formikRef?.current?.values?.origin,
              language: formikRef?.current?.values?.language,
              ages: formikRef?.current?.values?.ages,
              copyright: formikRef?.current?.values?.copyright,
              devices: formikRef?.current?.values?.devices,
              price: formikRef?.current?.values?.price,
              publishers: formikRef?.current?.values?.publishers,
              keywords: formikRef?.current?.values?.keywords,
              distributors: formikRef?.current?.values?.distributors,
            };
            singleBookUpload(
              book,
              formikRef?.current?.values?.bookfile,
              formikRef?.current?.values?.coverfile
            )
              .then((res) => {
                setMessage(res.data);
              })
              .catch((error) => {
                setMessage(error.response.data);
              });
          }}
        />
      </StyledContainer>
      <Dialog
        showButton={false}
        action={() => {
          setUploading(false);
          navigate("/books");
        }}
        onClose={() => {
          setUploading(false);
        }}
        open={uploading}
      >
        {message}
      </Dialog>
    </>
  );
};

export default EditBook;
